import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = ({ currentPage, setCurrentPage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLinkClick = (page) => {
    // Navigation avec URLs propres
    const routes = {
      'home': '/',
      'favorites': '/favorites',
      'about': '/about',
      'credits': '/credits',
      'mentions-legales': '/mentions-legales',
      'politique-confidentialite': '/politique-confidentialite'
    };
    
    navigate(routes[page] || '/');
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>SoundNest</h3>
          <p>Votre bibliothèque de sons libres de droits</p>
        </div>
        
        <div className="footer-section">
          <h4>Navigation</h4>
          <ul>
            <li>
              <button 
                onClick={() => handleLinkClick('home')}
                className={location.pathname === '/' ? 'active' : ''}
              >
                Accueil
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleLinkClick('favorites')}
                className={location.pathname === '/favorites' ? 'active' : ''}
              >
                Favoris
              </button>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>À propos</h4>
          <ul>
            <li>
              <button 
                onClick={() => handleLinkClick('about')}
                className={location.pathname === '/about' ? 'active' : ''}
              >
                À propos
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleLinkClick('credits')}
                className={location.pathname === '/credits' ? 'active' : ''}
              >
                Crédits
              </button>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Légal</h4>
          <ul>
            <li>
              <button 
                onClick={() => handleLinkClick('mentions-legales')}
                className={location.pathname === '/mentions-legales' ? 'active' : ''}
              >
                Mentions légales
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleLinkClick('politique-confidentialite')}
                className={location.pathname === '/politique-confidentialite' ? 'active' : ''}
              >
                Politique de confidentialité
              </button>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 SoundNest. Tous droits réservés.</p>
        <p>Sons fournis par <a href="https://lasonotheque.org" target="_blank" rel="noopener noreferrer">LaSonotheque.org</a></p>
      </div>
    </footer>
  );
};

export default Footer;
